var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.736 4.5H22.5C23.3284 4.5 24 5.17157 24 6V21C24 21.8284 23.3284 22.5 22.5 22.5H1.5C0.67157 22.5 0 21.8284 0 21V3C0 2.17157 0.67157 1.5 1.5 1.5H9C9.56754 1.4975 10.0875 1.81677 10.342 2.32404L11.289 4.224C11.3738 4.39319 11.5468 4.5 11.736 4.5ZM15.1673 16.286C16.2679 16.2864 17.1604 15.3946 17.161 14.294V9.26398C17.1623 8.67078 16.8982 8.10803 16.441 7.72998C15.9568 7.33643 15.3178 7.18878 14.71 7.33002L10.45 8.70502C9.5079 8.8833 8.82492 9.7052 8.82199 10.664V14.606C8.82199 14.806 8.685 14.824 8.61499 14.812C8.52054 14.7955 8.42487 14.7872 8.32901 14.787C7.2283 14.787 6.336 15.6793 6.336 16.78C6.336 17.8807 7.2283 18.773 8.32901 18.773C9.42969 18.773 10.322 17.8807 10.322 16.78V10.664C10.3365 10.3953 10.5469 10.1786 10.815 10.156L15.075 8.78101C15.219 8.75452 15.3674 8.7934 15.48 8.88696C15.5936 8.97986 15.6591 9.11926 15.658 9.26599V12.099C15.658 12.334 15.532 12.339 15.468 12.328C15.369 12.3102 15.2686 12.3008 15.168 12.3C14.0674 12.3 13.1752 13.1921 13.175 14.2927C13.1748 15.3932 14.0668 16.2856 15.1673 16.286Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMusic);
export default __webpack_public_path__ + "static/media/folderMusic.9c5b4640.svg";
export { ForwardRef as ReactComponent };